// getAllCompany,
import {getAllSalesReps, getAllPhysician, corporation, exportAutoCaseLog} from '../../../service/service'

export default {
    name: 'automatic-viewing',
    data: function () {
        return {
            data2: [],
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            dateViewed: '',
            keywordSearch: '',
            searchMark:false,
            timeoutId:'',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    width: 150,tooltip:true,
                    key: 'CaseId'
                }, {
                    title: this.$t('sales rep'),
                    minWidth: 80,tooltip:true,
                    key: 'Sales'
                },
                {
                    title: this.$t('physician'),
                    minWidth: 80,tooltip:true,
                    key: 'Physician'
                },
                {
                    title: this.$t('specialty'),
                    minWidth: 60,tooltip:true,
                    key: 'Specialty'
                },
                {
                    title: this.$t('patient name'),
                    minWidth: 100,tooltip:true,
                    key: 'PatientName'
                },
                {
                    title: this.$t('patient id'),
                    minWidth: 60,tooltip:true,
                    key: 'PatientId'
                },
                {
                    title: this.$t('hospital'),
                    minWidth: 100,tooltip:true,
                    key: 'Hospital'
                },
                {
                    title: this.$t('date viewed'),
                    minWidth: 80,tooltip:true,
                    key: 'DateViews'
                },
                {
                    title: this.$t('date of surgery'),
                    minWidth: 80,tooltip:true,
                    key: 'DateOfSurgery'
                },
                {
                    title: this.$t('add note'),
                    minWidth: 60,tooltip:true,
                    slot: 'action'
                },
                {
                    title: this.$t('more info'),
                    minWidth: 60,tooltip:true,
                    slot: 'more'
                }
            ],
            data1: [],
            modal: false,
            modal1: false,
            txtComment: '',
            showDetailModal: false,
            commentList: [],
            pagesize: 20,
            pageTo: "1",
            page: 1,
            token: '',
            arrTree: [],
            tempTree:[],
            physiciansList:[],
            // eslint-disable-next-line no-dupe-keys
            tid: 0,
            tname: '',
            dataInfo: null,
            isSelectTree: false,
            chooseRow: [{'caseId':'caseId'}]
        }
    },
    methods: {
        toCsv() {
            console.log(JSON.stringify(this.chooseRow))
            exportAutoCaseLog({
                "userId": this.token,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        // pageInput(){
        //     if(this.page){
        //         this.page = parseInt(this.page)
        //     }
        // },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        reloadView() {
            let obj = {
                "userId": this.token,
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch
            }
            obj["physicianList"] = JSON.stringify(this.arrTree)
            console.log(JSON.stringify(this.arrTree));
            corporation.automatic.getAutomaticData(obj).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    console.log(data)
                    this.data1 = data.list
                    // console.log(JSON.parse(data.list))
                    this.total = data.total
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                }
            })
        },
        changePatientName() {
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        selectTree(e){
            console.log("csaasd"+e.length)
            this.page = 1
            this.pageTo = 1
            let arr = []
            this.isSelectTree = true;
            if(e.length > 0) {
                e.forEach(i => {
                    if(!i.children){
                        let obj = {
                            physicianID: i.id
                        }
                        arr.push(obj)
                    }
                });
            }
            console.log(this.physiciansList)
            if (arr != null && arr.length > 0){
                this.arrTree = arr
            } else {
                this.arrTree = this.tempTree;
            }
            this.reloadView()
        },
        addComment1() {
            this.modal1 = true
        },
        changePageSize(size) {
            this.page = 1
            this.pagesize = size
            this.pageTo = 1
            this.reloadView()
        },
        showDetail(row) {
            this.tid = row.CaseId
            this.tname = row.name
            let p = {
                userId: this.token,
                id: this.tid
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            corporation.automatic.getAutomaticInfo(p).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    this.dataInfo = data
                    console.log(data)
                    corporation.automatic.getAutomaticComment(p).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                        } else {
                            this.$Message.warning(this.$t('fail'))
                        }
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        ok1() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = localStorage.getItem('userName')
            let obj = {
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            corporation.automatic.addAutomaticComment(obj).then(res => {
                console.log(res)
                let code = parseInt(res.code)
                if (!code) {
                    this.txtComment = ''
                    this.tname = ''
                    this.modal1 = false
                    corporation.automatic.getAutomaticComment({
                        userId: this.token,
                        id: this.tid
                    }).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide();
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                        }
                    })
                    this.txtComment = ''
                    this.tname = ''
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel1() {
            this.tid = 0
            this.txtComment = ''
            this.tname = ''
            this.modal1 = false
        },
        ok() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = localStorage.getItem('userName')
            let obj = {
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            corporation.automatic.addAutomaticComment(obj).then(res => {
                console.log(res)
                this.$Spin.hide();
                let code = parseInt(res.code)
                if (!code) {
                    this.modal = false
                    this.tid = 0
                    this.txtComment = ''
                    this.tname = ''
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel() {
            this.tid = 0
            this.txtComment = ''
            this.tname = ''
            this.modal = false
        },
        addComment(row, index) {
            console.log(row)
            console.log(index)
            this.tid = row.id
            this.tname = row.name
            this.modal = true
        },
        showDate() {
            // console.log(this.dateOfSurgery)
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        dateChange1(e) {
            this.page = 1
            this.pageTo = 1
            this.dateViewed = e
            this.reloadView()
        },
        dateChange(e) {
            this.page = 1
            this.pageTo = 1
            this.dateOfSurgery = e
            this.reloadView()
        }
    },
    created() {

    },
    mounted() {
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        let arr = [];
        let arr2 = [];
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        getAllSalesReps({UserUID: this.token}).then(res => {
            let markcount  = res.SalesReps.length;
            res.SalesReps.forEach(i => {
                let obj = {
                    id: i.SalesId,
                    title: i.SalesName,
                    expand: true,
                    children: []
                }
                let entity = i;
                getAllPhysician({UserUID: this.token}).then(res => {
                    // console.log(res)
                    let childcount =  res.Physician.length;
                    arr.push(obj);
                    res.Physician.forEach(m => {
                        childcount = childcount - 1;
                        if (entity.SalesId === m.SalesId) {
                            let opj1 = {
                                id: m.DocId,
                                title: m.DocName,
                                expand: true
                            }
                            obj.children.push(opj1)
                            let objphy = {
                                physicianID: m.DocId
                            }
                            arr2.push(objphy)
                            console.log("arr2:"+arr2.length)
                            this.physiciansList.push(objphy);
                        }
                        if (childcount === 0){
                            let otherObj = {
                                title: 'Other',
                                id: i.SalesId + '_other',
                                expand: true
                            }
                            obj.children.push(otherObj)
                            let objphy = {
                                physicianID: i.SalesId + '_other'
                            }
                            arr2.push(objphy)
                            this.physiciansList.push(objphy);
                            markcount = markcount - 1;
                        }
                        if (markcount === 0){
                            let obj = {
                                id: this.token+"_OTHERS",
                                title: "Others",
                            }
                            arr.push(obj);
                            let objphy = {
                                physicianID: this.token + '_OTHERS'
                            }
                            arr2.push(objphy)
                            this.data2 = arr;
                            this.arrTree = arr2;
                            this.tempTree = arr2;
                            this.reloadView()
                        }
                    })
                })
            });

        })
    }
}
